import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useEffect, useState } from "react";

export default function DashboardLayout() {
  // Desktop: collapsed (icon-only)
  const [collapsed, setCollapsed] = useState(false);
  // Mobile: drawer open/closed (overlay style, doesn't push content)
  const [mobileOpen, setMobileOpen] = useState(false);

  const location = useLocation();

  // Auto-close the mobile drawer whenever the route changes (link tap)
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Lock body scroll while the mobile drawer is open
  useEffect(() => {
    if (mobileOpen) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = prev;
      };
    }
  }, [mobileOpen]);

  const handleToggle = () => {
    // < lg breakpoint → toggle the drawer; ≥ lg → toggle desktop collapse
    if (window.matchMedia("(max-width: 1023px)").matches) {
      setMobileOpen((v) => !v);
    } else {
      setCollapsed((c) => !c);
    }
  };

  return (
    <div className="flex min-h-screen bg-[#F8F9FA]" data-testid="dashboard-layout">
      <Sidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />
      <div className="flex-1 min-w-0 flex flex-col">
        <Topbar onToggleSidebar={handleToggle} />
        <main className="flex-1 p-3 sm:p-5 lg:p-8 fade-in-up">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
